module.exports = "(function() {\r\n    'use strict';\r\n\r\n    angular.module('blocks.exception', ['blocks.logger']);\r\n})();\r\n"